import React, { useState } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './App.css';

import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ProjectsPage from './pages/ProjectsPage';
import LandingPage from './pages/LandingPage';
import { AnimatedSwitch } from "react-router-transition";


function App () {
  const [landing, setLanding] = useState(1);
  return (
    <Router>
      <LandingPage
      landing={landing}
      setLanding={setLanding}
      />
      <Navigation
      setLanding={setLanding}
      />
      <AnimatedSwitch
        atEnter={{ opacity: 0 }}
        atLeave={{ opacity: 0 }}
        atActive={{ opacity: 1 }}
        className="switch-wrapper"
        >
        <Route exact path="/" component={HomePage} />
        <Route path="/about" component={AboutPage} />
        <Route path="/contact" component={ContactPage} />
        <Route path="/projects" component={ProjectsPage} />
        {/* <Route path="/*" component={Navigation} /> */}
      </AnimatedSwitch>
    </Router>
  );
}

export default App;
